import { safeParse } from '@/utils/helpers';

export default {
  namespaced: true,
  state: {
    isFetched: false,
    currentCompetition: {
      isLive: false,
      distributorCompanyCode: '',
      name: 'TEST_COMPETITION',
      domain: 'studioevent',
      finishByTimer: false,
      options: {
        showCompetitionBanner: false,
        isEventStarted: false,
        isLastParticipantSchoolShown: false,
        isTesting: false
      }
    }
  },
  getters: {
    competition(state) {
      return state.currentCompetition;
    },
    hasCompetition(state) {
      return !!(
        state.currentCompetition && state.currentCompetition.studioEventId
      );
    },
    competitionName(state) {
      return state.currentCompetition.name;
    },
    isCompetitionFetched(state) {
      return state.isFetched;
    }
  },
  mutations: {
    setCurrentCompetition(state, competition) {
      if (competition !== null) {
        state.currentCompetition = {
          ...competition,
          options: safeParse(competition.options)
        };
      }
    },
    setIsCompetitionFetched(state, isFetched) {
      state.isFetched = isFetched;
    }
  },
  actions: {
    fetchCurrentCompetition({ state, commit, rootGetters }) {
      if (state.isFetched) {
        return Promise.resolve();
      }

      const PATH_QUERY = '/studio-event?search=isLive==true';

      return rootGetters['CodementumUser/apiRequest']({
        method: 'get',
        path: PATH_QUERY,
        onSuccess(data) {
          if (data && data.list && data.list.length > 0) {
            commit('setCurrentCompetition', data.list[0]);
          } else {
            commit('setCurrentCompetition', null);
          }
        },
        onFailure() {
          commit('setCurrentCompetition', null);
        }
      });
    }
  }
};
